import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetUserById, GetUserPermissions } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";

const ViewUser = () => {
  let param = useParams();
  const user_id_id = param.user_id;
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirm_password: "",
    role_desc: "",
    role: "select",
    user_company: "select",
  });

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Users");
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (user_id_id) {
        TimeoutUtility.resetTimeout();
        GetUserPermissions(user_id_id)
          .then((resp) => {
            const groupedItems = resp.data.reduce(
              (acc, item) => {
                if (acc[acc.length - 1].length >= 4) return [...acc, [item]];
                acc[acc.length - 1].push(item);
                return acc;
              },
              [[]],
            );
            setPermissions(groupedItems || []);
          })
          .catch((err) => console.log(err.message));
        GetUserById(user_id_id)
          .then((result) => {
            setFormData({
              username: result.data.username,
              password: result.data.password,
              confirm_password: "",
              role_desc: result.data.role_desc,
              role: {
                label: result.data.role,
                value: result.data.role_id,
              },
              user_company: result.data.company_id
                ? {
                    label: result.data.company,
                    value: result.data.company_id,
                  }
                : "select",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [user_id_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW USER" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Username:"
                  name="username"
                  value={formData.username}
                  placeholder="Username"
                  disabled
                />
                <SelectField
                  label="Role:"
                  name="role"
                  value={formData.role}
                  placeholder="Role"
                  isDisabled
                />
                <SelectField
                  label="Company:"
                  name="user_company"
                  value={formData.user_company}
                  placeholder="Company"
                  isDisabled
                />
                <TextAreaField
                  label="Role Description:"
                  name="role_desc"
                  value={formData.role_desc}
                  placeholder="Role Description"
                  disabled
                />
              </div>
            </Col>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label mb-1">Permissions:</label>
                  {permissions.map((items, index) => (
                    <Row key={index}>
                      {items.map((item, i) => (
                        <Col key={i} md={3} style={{ paddingRight: "0px" }}>
                          <label
                            className="label-checkbox"
                            style={{
                              fontSize: "14px",
                              width: "100%",
                              cursor: "default",
                            }}
                          >
                            <input
                              className="checkbox"
                              name="SelectAll"
                              type="checkbox"
                              value={item.permission_id}
                              checked={item.check}
                              disabled
                            />
                            {` ${item.name}`}
                          </label>
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewUser;
